export function initMenuToggle() {
    const toggle = document.querySelector('.main-nav__toggle');
    const panel = document.getElementById('mobile-nav-panel');
    if (!toggle || !panel) return;

    const closePanel = () => {
        panel.classList.remove('mobile-nav-panel--open');
        toggle.setAttribute('aria-expanded', 'false');
    };
    const openPanel = () => {
        panel.classList.add('mobile-nav-panel--open');
        toggle.setAttribute('aria-expanded', 'true');
    };

    toggle.addEventListener('click', () => {
        const isOpen = panel.classList.contains('mobile-nav-panel--open');
        isOpen ? closePanel() : openPanel();
    });

    panel.querySelectorAll('[data-close-panel]').forEach((el) => {
        el.addEventListener('click', closePanel);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && panel.classList.contains('mobile-nav-panel--open')) {
            closePanel();
            toggle.focus();
        }
    });

    panel.addEventListener('click', (event) => {
        const submenuToggle = event.target.closest('.mobile-nav__toggle-submenu');
        if (!submenuToggle) return;
        const submenu = submenuToggle.closest('li').querySelector(':scope > .mobile-nav__submenu');
        if (!submenu) return;
        const isOpen = submenu.classList.toggle('is-open');
        submenuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
}
